__turbopack_context__.v({
  "address": "ContactPageContentEditorial-module__AAB3Va__address",
  "addressLine": "ContactPageContentEditorial-module__AAB3Va__addressLine",
  "contactDetails": "ContactPageContentEditorial-module__AAB3Va__contactDetails",
  "container": "ContactPageContentEditorial-module__AAB3Va__container",
  "divider": "ContactPageContentEditorial-module__AAB3Va__divider",
  "email": "ContactPageContentEditorial-module__AAB3Va__email",
  "formPanel": "ContactPageContentEditorial-module__AAB3Va__formPanel",
  "headline": "ContactPageContentEditorial-module__AAB3Va__headline",
  "intro": "ContactPageContentEditorial-module__AAB3Va__intro",
  "layout": "ContactPageContentEditorial-module__AAB3Va__layout",
  "layoutDivider": "ContactPageContentEditorial-module__AAB3Va__layoutDivider",
  "leftColumn": "ContactPageContentEditorial-module__AAB3Va__leftColumn",
  "newBusiness": "ContactPageContentEditorial-module__AAB3Va__newBusiness",
  "newBusinessBody": "ContactPageContentEditorial-module__AAB3Va__newBusinessBody",
  "newBusinessContent": "ContactPageContentEditorial-module__AAB3Va__newBusinessContent",
  "newBusinessCta": "ContactPageContentEditorial-module__AAB3Va__newBusinessCta",
  "newBusinessDetails": "ContactPageContentEditorial-module__AAB3Va__newBusinessDetails",
  "newBusinessHeading": "ContactPageContentEditorial-module__AAB3Va__newBusinessHeading",
  "newBusinessLine": "ContactPageContentEditorial-module__AAB3Va__newBusinessLine",
  "newBusinessLineMuted": "ContactPageContentEditorial-module__AAB3Va__newBusinessLineMuted",
  "newBusinessLinkIcon": "ContactPageContentEditorial-module__AAB3Va__newBusinessLinkIcon",
  "newBusinessMedia": "ContactPageContentEditorial-module__AAB3Va__newBusinessMedia",
  "newBusinessPortrait": "ContactPageContentEditorial-module__AAB3Va__newBusinessPortrait",
  "newBusinessSection": "ContactPageContentEditorial-module__AAB3Va__newBusinessSection",
  "page": "ContactPageContentEditorial-module__AAB3Va__page",
  "pullQuote": "ContactPageContentEditorial-module__AAB3Va__pullQuote",
  "pullQuoteText": "ContactPageContentEditorial-module__AAB3Va__pullQuoteText",
  "quoteSection": "ContactPageContentEditorial-module__AAB3Va__quoteSection",
  "rightColumn": "ContactPageContentEditorial-module__AAB3Va__rightColumn",
});
